import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useTheme } from '@emotion/react';
import { Div, H1, H2, H3, H4, H5, H6, Span, Link, Label, Button, Strong, ListItem, Paragraph } from '../Element/index.js';
const ELEMENT_TO_HTML = {
    h1: H1,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: H5,
    h6: H6,
    a: Link,
    div: Div,
    span: Span,
    li: ListItem,
    p: Paragraph,
    strong: Strong,
    label: Label,
    button: Button
};
export const Typography = memo(forwardRef((props, ref) => {
    const { children, element, style, ...restProps } = props;
    const TypographyElement = ELEMENT_TO_HTML[element];
    const theme = useTheme();
    const styles = typeof style === 'function' ? style(theme) : style;
    return (_jsx(TypographyElement, { ...restProps, styles: styles, ref: ref, children: children }));
}));
export default Typography;
//# sourceMappingURL=index.js.map